import React from 'react';
import "./cwsHeader.scss";
/*import Logo from '../../assets/images/barclays-landscape_logo.gif';*/
import Barclays_Logo from '../../assets/images/barclays_logo.svg';

const CwsHeader=()=>{
  return (
    <div className="container-fluid header-wrapper" id="cws-header">
      <div className="row">
        <div className="col-xs-12 col-md-12">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-12">
                <div className="header">
                  <div className="logo-wrapper">
                    <img className={`header-theme-barclays`} src={Barclays_Logo} alt="Barclays logo"/>
                    <span className="barclays-text">Barclays Personal Loan</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CwsHeader;
